/**
 * TelemetryManager is a singleton class that manages the OpenTelemetry
 * provider and tracer. It provides methods to start and end traces and spans,
 * and to get the headers for the active trace or span.
 * It also provides methods to start, end, and get headers for managed spans.
 * Managed spans are spans that are created by the TelemetryManager
 * and are not directly associated with the current context.
 */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
export var TelemetryManagerNoOp = function TelemetryManagerNoOp() {
    "use strict";
    _class_call_check(this, TelemetryManagerNoOp);
    this.initialize = function(_serviceName, _consoleProvider) {
        return;
    };
    this.startTrace = function(_name, _attributes, _options, _useSerializedTraceContext) {
        return;
    };
    this.endTrace = function(_name, _attributes) {
        return;
    };
    this.getActiveTraceHeaders = function() {
        return;
    };
    this.getActiveTraceId = function() {
        return;
    };
    this.startSpan = function(_name, _attributes, _parentSpan, _root) {
        return;
    };
    this.endSpan = function(span) {
        span === null || span === void 0 ? void 0 : span.end();
    };
    this.startManagedSpan = function(_name, _attributes, _options) {
        return;
    };
    this.endManagedSpan = function(_spanId, _attributes) {};
    this.getManagedSpan = function(_spanId) {
        return null;
    };
    this.getSpanRequestHeaders = function(_span) {
        return;
    };
};
